module.exports = __webpack_public_path__ + "static/media/wave.dcf99abf.mp4";